import { TEXTE } from '@/configuration/jsonEditor/jsonEditorConfig';

export default function genererChamp() {
  return {
    label: null,
    name: null,
    type: TEXTE,
    propertyOrder: null,
    defaultValue: null,
    arrayValues: [],
  };
}
